<template>
  <v-container fluid>
    <v-row v-for="(row, index) in props.layout.rows" :key="index">
      <v-col
        v-for="(col, index) in row"
        :key="index"
        :cols="col.cols"
      >
        <div>
          <span class="data-inline-data-title">
            {{ col.label }}
          </span>
          <div
            :class="
              col.class
                ? col.class
                : ['data-inline-data', 'text-justify']
            "
          >
            <Field
              :field="current_qunit[col.id]"
              :unit="current_qunit"
            />
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Field from '@/components/qfields/Field'

export default {
  name: 'InlineBoxSimpleLayout',

  props: {
    current_qunit: Object,
    props: Object,
  },

  components: {
    Field,
  },
}
</script>
<style lang="scss">
@import '@/sass/explorer.scss';
</style>
